import { FC, ReactNode, useEffect } from 'react';
import _ from 'lodash';
import {
  useTemplatesContext,
  APP_STATUS,
} from '@components/Contexts/TemplatesContext';
import { Box, StatusIndicator } from '@wix/design-system';
import { TemplateGalleryCard, TemplateQueryResponse } from '@common/types';
import { useIntersectionObserver } from 'usehooks-ts';
import { InfiniteData } from '@tanstack/react-query';
import TemplateCardListItems from '@components/Templates/TemplateGallery/TemplateCardListItems';
import TemplateCardAdaptive from '@components/Templates/TemplateGallery/TemplateCard/TemplateCardAdaptive';
import TemplateCardListItemsLoadingState from '@components/Templates/TemplateGallery/TemplateCardListItems/TemplateCardListItemsLoadingState';
import s from '../GalleryGrid/GalleryGrid.module.scss';

type Props = {
  hasNextPage: boolean;
  fetchNextPage: Function;
  templatesPages?:
    | InfiniteData<TemplateQueryResponse | undefined, unknown>
    | undefined;
  getActionButton?: (template: TemplateGalleryCard) => ReactNode;
};
const GalleryGridMobile: FC<Props> = ({
  templatesPages,
  hasNextPage,
  fetchNextPage,
  getActionButton,
}) => {
  const {
    state: { appStatus },
  } = useTemplatesContext();
  const { isIntersecting, ref } = useIntersectionObserver({});

  useEffect(() => {
    if (isIntersecting && hasNextPage) {
      fetchNextPage();
    }
  }, [isIntersecting, hasNextPage]);

  return (
    <>
      <div className={s.gridContainer}>
        <ul className={`${s.content} ${s.mobileView}`}>
          {_.map(templatesPages?.pages, (page, index) => (
            <TemplateCardListItems
              CardComponent={TemplateCardAdaptive}
              LoadingState={TemplateCardListItemsLoadingState}
              templates={page?.templates}
              isMobileView={true}
              getActionButton={getActionButton}
              actionButtonVisibility="always"
            />
          ))}
        </ul>
      </div>
      {appStatus !== APP_STATUS.ERROR && hasNextPage && (
        <div ref={ref} data-hook="infiniteScroll-container">
          <Box marginTop="26px" align="center" verticalAlign="middle">
            <StatusIndicator status="loading" />
          </Box>
        </div>
      )}
    </>
  );
};

export default GalleryGridMobile;
